import { ReactNode } from 'react'

import { PrismicRichText as PrismicRichTextComponent } from '@prismicio/react'
import { Box, Sx, Typography } from '@dhl/theme'

const classes: Record<string, Sx> = {
  paragraph: {
    fontSize: '0.8rem',
    lineHeight: '140%',
    fontFamily: 'Delivery Regular',
  },
  image: {
    maxHeight: 200,
    maxWidth: '100%',
    margin: 0,
    marginTop: (theme) => theme.spacing(2),
  },
  h1: {
    fontWeight: 'bold',
    fontSize: '0.9286rem',
    paddingTop: '16px',
  },
}

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  paragraphClass?: string
}

export const PrismicRichText = ({ children, paragraphClass }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function htmlSerializer(type: string, element: any, text: string | undefined, chldrn: ReactNode) {
    switch (type) {
      case 'strong':
        return text ? <strong key={text}>{text}</strong> : null

      case 'image':
        return (
          <Box key={element.url} display="flex" justifyContent="center">
            <Box component="img" src={element.url} alt={element.alt} sx={classes.image} />
          </Box>
        )

      case 'paragraph':
        if (!element.text) {
          return null
        }
        return (
          <Typography key={element.text} component="p" sx={[classes.paragraph, paragraphClass] as Sx}>
            {chldrn}
          </Typography>
        )

      case 'list-item':
        if (!element.text) {
          return null
        }
        return (
          <Typography key={element.text} component="li">
            {chldrn}
          </Typography>
        )

      case 'heading1':
        return (
          <Typography key={element.text} sx={classes.h1}>
            {chldrn}
          </Typography>
        )

      default:
        // null means default behaviour
        return null
    }
  }

  return <PrismicRichTextComponent field={children} components={htmlSerializer} />
}
